import LocalizedStrings from 'react-localization';
import en from './languages/en';
import fr from './languages/fr';

let strings = new LocalizedStrings({
  en: en,
  fr:fr,
});

export default strings;
